export const GENDER_CATEGORIES = [
  { category: "Men" },
  { category: "Women" },
  { category: "Kids" },
];

export const BRANDS = [
  { name: "Adidas" },
  { name: "Blundstone" },
  { name: "Birkenstock" },
  { name: "Crocs" },
  { name: "Columbia" },
  { name: "Converse" },
  { name: "Diadora" },
  { name: "DC Shoes" },
  { name: "Dr. Martens" },
  { name: "ECCO" },
  { name: "Geox" },
  { name: "New Balance" },
  { name: "Nike" },
  { name: "Saucony" },
  { name: "Skechers" },
  { name: "Vans" },
  { name: "Puma" },
  { name: "Reebok" },
  { name: "Timberland" },
];

export const TYPES = [
  { type: "Sandals" },
  { type: "Shoes" },
  { type: "Sneakers" },
  { type: "Boots" },
];

export const SIZES = [
  { size: "15" },
  { size: "16" },
  { size: "17" },
  { size: "18" },
  { size: "19" },
  { size: "20" },
  { size: "21" },
  { size: "22" },
  { size: "23" },
  { size: "24" },
  { size: "25" },
  { size: "26" },
  { size: "27" },
  { size: "28" },
  { size: "29" },
  { size: "30" },
  { size: "31" },
  { size: "32" },
  { size: "33" },
  { size: "34" },
  { size: "35" },
  { size: "36" },
  { size: "37" },
  { size: "38" },
  { size: "39" },
  { size: "40" },
  { size: "41" },
  { size: "42" },
  { size: "43" },
  { size: "44" },
  { size: "45" },
  { size: "46" },
  { size: "47" },
];

export const KIDS_SIZES = [
  { size: "15" },
  { size: "16" },
  { size: "17" },
  { size: "18" },
  { size: "19" },
  { size: "20" },
  { size: "21" },
  { size: "22" },
  { size: "23" },
  { size: "24" },
  { size: "25" },
  { size: "26" },
  { size: "27" },
  { size: "28" },
  { size: "29" },
  { size: "30" },
  { size: "31" },
  { size: "32" },
  { size: "33" },
  { size: "34" },
  { size: "35" },
  { size: "36" },
  { size: "37" },
  { size: "38" },
  { size: "39" },
];

export const WOMEN_SIZES = [
  { size: "35" },
  { size: "36" },
  { size: "37" },
  { size: "38" },
  { size: "39" },
  { size: "40" },
  { size: "41" },
  { size: "42" },
  { size: "43" },
];

export const MEN_SIZES = [
  { size: "39" },
  { size: "40" },
  { size: "41" },
  { size: "42" },
  { size: "43" },
  { size: "44" },
  { size: "45" },
  { size: "46" },
  { size: "47" },
];
